import { useQuery } from '~/client/hooks/cqrpc'
import SessionsList from '~/client/components/SessionsList'

export default function MySessionsList(){
  const query = useQuery('sessions.getMine')
  return <SessionsList {...{
    loading: query.loading,
    sessions: query.result,
    error: query.error,
  }}/>
}
